<div class="faq-list">
  @for (item of questionsAndAnswers; track item.question; let i = $index) {
    <details class="qa" [hidden]="!showAll && i >= visibleCount">
      <summary>{{ item.question }}<span class="qa-ic" aria-hidden="true"></span></summary>
      <div class="qa-body">
        <p>{{ item.answer }}</p>
      </div>
    </details>
  }
</div>

@if (questionsAndAnswers.length > visibleCount) {
  <div class="faq-more">
    <button type="button" (click)="toggleAll()" [attr.aria-expanded]="showAll">
      {{ showAll ? 'نمایش کمتر' : 'نمایش همهٔ سوال‌ها' }}
    </button>
  </div>
}
